export default "__VITE_ASSET__vd121wJx__"